export default [
  {
    key: 'code',
    label: 'field.sectionUsedCode',
    type: 'text',
    operator: '%',
  },
  {
    key: 'name',
    label: 'field.sectionUsedName',
    type: 'text',
    operator: '%',
  },
  {
    key: 'isEnable',
    label: 'field.status',
    rules: 'required',
    type: 'radio',
    cast: 'boolean',
    options: [
      { text: 'status.active', value: '1' },
      { text: 'status.inactive', value: '0' },
    ],
  },
];
